import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import HomePage from './pages/HomePage';
import RegistrosPage from './pages/RegistrosPage';
import EscolaridadPage from './pages/EscolaridadPage';
import Sidebar from './components/Sidebar';
import Topbar from './components/Topbar';

// Este componente sí está dentro del contexto del Router
const AppContent = () => {
  const location = useLocation();
  const showSidebar = location.pathname !== '/registros';

  return (
    <div className="app-container">
      {showSidebar && <Sidebar />}
      <Topbar />
      <div className={`main-content ${!showSidebar ? 'no-padding' : ''}`}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/escolaridad" element={<EscolaridadPage />} />
          <Route path="/registros" element={<RegistrosPage />} />
        </Routes>
      </div>
    </div>
  );
};

// El componente App ahora solo envuelve a AppContent con el Router
const App = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

export default App;